// extracted by mini-css-extract-plugin
module.exports = {"close":"close-1N2tn"};